import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create({
  container: {
    paddingVertical: theme.spacing[4],
    // Center the two-line footnote horizontally and keep it responsive: the
    // block never exceeds the sheet width and each line is center-aligned.
    alignItems: 'center',
    alignSelf: 'stretch',
    gap: theme.spacing[1],
  },
  legalLink: {
    textDecorationLine: 'underline',
  },
});
